export enum applicantsPrTypes {
  FETCH_APPLICANTS_PR_REQUEST = "FETCH_APPLICANTS_PR_REQUEST",
  FETCH_APPLICANTS_PR_SUCCESS = "FETCH_APPLICANTS_PR_SUCCESS",
  FETCH_APPLICANTS_PR_FAILURE = "FETCH_APPLICANTS_PR_FAILURE",
}